import { IParams, IValidation } from './types'

export function initialParams(): IParams {
  return { password: '' }
}

export function validate(params: IParams) {
  const { password } = params
  const validation: IValidation = {}

  if (!password) {
    validation.password = 'Please enter a password'
  } else if (password.length < 2) {
    validation.password = 'Please enter a longer password'
  }

  return validation
}
